import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkle16Filled } from '@fluentui/react-icons';
import styles from './askAi.module.css';

const TABS = [
    { key: 'ask', label: 'Ask Lens', path: '/lens-intelligence' },
    { key: 'insights', label: 'Intelligence Insights', path: '/lens-intelligence/insights' },
    { key: 'readiness', label: 'Investment Readiness', disabled: true },
    { key: 'outlook', label: 'AI Outlook', disabled: true },
    { key: 'more', label: 'More', disabled: true },
];

/**
 * Shared Lens Intelligence chrome: brand header + tab bar.
 */
const LensIntelligenceShell = ({ activeTab = 'ask', sourcesReady = null, sourcesProcessing = null, children }) => {
    const navigate = useNavigate();
    const readyCount = sourcesReady != null ? Number(sourcesReady) : null;
    const processingCount = sourcesProcessing != null ? Number(sourcesProcessing) : null;
    const showStatus = readyCount != null;

    return (
        <div className={styles.shell}>
            <header className={styles.shellHeader}>
                <div className={styles.brand}>
                    <span className={styles.brandIcon} aria-hidden>
                        <Sparkle16Filled />
                    </span>
                    <span className={styles.brandTitle}>Lens Intelligence</span>
                </div>
                {showStatus ? (
                    <div className={styles.sourcesStatus}>
                        <span className={styles.sourcesDot} aria-hidden />
                        <span className={styles.sourcesReadyText}>{readyCount} sources ready</span>
                        {processingCount != null && processingCount > 0 ? (
                            <>
                                <span className={styles.sourcesSep}>·</span>
                                <span className={styles.sourcesProcessingText}>{processingCount} processing</span>
                            </>
                        ) : null}
                    </div>
                ) : null}
            </header>

            <nav className={styles.tabBar} aria-label="Lens Intelligence">
                {TABS.map(tab => {
                    const isActive = tab.key === activeTab;
                    if (tab.disabled) {
                        return (
                            <button
                                key={tab.key}
                                type="button"
                                className={`${styles.tab} ${styles.tabDisabled}`}
                                // disabled
                                title="Coming soon">
                                {tab.label}
                            </button>
                        );
                    }
                    return (
                        <button
                            key={tab.key}
                            type="button"
                            className={`${styles.tab} ${isActive ? styles.tabActive : ''}`}
                            onClick={() => {
                                if (!isActive && tab.path) navigate(tab.path);
                            }}>
                            {tab.label}
                        </button>
                    );
                })}
            </nav>

            <div className={styles.shellBody}>{children}</div>
        </div>
    );
};

export default LensIntelligenceShell;
